const router = [
  {
    path: "/login/googleBind/:arg?",
    name: "loginGoogleBind",
    component: () => import("@/views/login/googleBind.vue"),
    meta: {
      keepAlive: false,
    },
  },
  {
    path: "/login/forgetPassword/:arg",
    name: "loginForgetPassword",
    component: () => import("@/views/login/forgetPassword.vue"),
    meta: {
      keepAlive: false,
    },
  },
  {
    path: "/login/welcomeBruce/:arg?",
    name: "loginWelcomeBruce",
    component: () => import("@/views/login/welcomeBruce.vue"),
    meta: {
      keepAlive: false,
    },
  },
  {
    path: "/login/information/:arg?",
    name: "loginInformation",
    component: () => import("@/views/login/information.vue"),
    meta: {
      keepAlive: false,
    },
  },
  {
    path: "/login/setPass/:arg",
    name: "loginSetPass",
    component: () => import("@/views/login/setPass.vue"),
    meta: {
      keepAlive: false,
    },
  },
  {
    path: "/login/:arg?",
    name: "login",
    component: () => import("@/views/login/index.vue"),
    meta: {
      keepAlive: false,
    },
  },
];

export default router;
